<div class="table-container">
  @if (loader.message) {
    <div class="loader-class">
      <mat-spinner color="primary"></mat-spinner>
      <div class="loader-message">{{loader.message}}</div>
    </div>
  }
  @if (errorMessage) {
    <div class="error-container">
      <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
      <div class="loader-message">{{errorMessage}}</div>
    </div>
  }
  @if (!loader.isLoading && !errorMessage) {
    <app-table-template [tableData]="tableData" [columnList]="columnList"
      [multiSortMeta]="multiSortMeta" sortMode="multiple" [rowClickable]="true"
      (actionButtonClicked)="handleButtonClicked($event)" [loading]="false"
      (pageDetails)="rewriteRouteQueryParams($event.page, $event.rows)"
      [page]="page" [rowsPerPage]="rowsPerPage" [rowsPerPageOptions]="rowsPerPageOptions">
      <div class="header-container div-entries-action">
        <p-button label="New Submission" icon="pi pi-plus" [raised]="true" severity="secondary"
          title="Create a new Success entry" (onClick)="goToNewSubmission()" />
        <p-button label="Export Entries" title="Export Entries in CSV format" [raised]="true" 
          (onClick)="exportEntries()" />
      </div>
    </app-table-template>
  }
</div>
<!-- Defer this block to load only when user clicks export entry icon -->
@defer (when powerPointExportData?.exportInitiated) {
  @if (powerPointExportData?.exportInitiated) {
    <app-export-powerpoint  [powerPointExportData]="powerPointExportData"
      (exportCompleted)="onExportCompleted($event)">
    </app-export-powerpoint>
  }
}
@loading {
  <div class="loader-class">
    <mat-spinner color="primary"></mat-spinner>
    <div class="loader-message">Exporting Success Entry to PowerPoint...</div>
  </div>
}